import { useState } from 'react';

import { Box, Typography } from '@mui/material';

import { BonusesTabsEnum } from './constants';
import { DailyBonusesPageTabs } from './DailyBonusesPageTabs';
import { DailyBonusesResetControls } from './DailyBonusesRefreshControls';

import css from './DailyBonusesPage.module.css';

import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { DailyReward } from 'v2/pages/dailyReward';
import { DailyTask } from 'v2/pages/dailyTask';
import { SpinBannerSettingsPage } from 'v2/pages/spinBanner';

export const DailyBonusesPage = () => {
  const [currentTab, setCurrentTab] = useState<BonusesTabsEnum>(BonusesTabsEnum.DAILY_REWARD);

  const setTab = (value: BonusesTabsEnum) => {
    setCurrentTab(value);
  };

  const renderDailyBonusesByCurrentTab = () => {
    switch (currentTab) {
      case BonusesTabsEnum.DAILY_REWARD: {
        return <DailyReward />;
      }
      case BonusesTabsEnum.DAILY_TASK: {
        return <DailyTask />;
      }
      case BonusesTabsEnum.SPIN_BANNER: {
        return <SpinBannerSettingsPage />;
      }
      default: {
        return null;
      }
    }
  };

  return (
    <PageLayout>
      <Typography margin="10px" fontSize="24px" fontWeight={600}>
        Daily Bonuses Settings
      </Typography>
      <>
        <Box className={css.settingsHeader}>
          <DailyBonusesPageTabs setTab={setTab} currentTab={currentTab} />
          <DailyBonusesResetControls />
        </Box>
        {renderDailyBonusesByCurrentTab()}
      </>
    </PageLayout>
  );
};
